import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase only once
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Analytics instance — lazily resolved
let analyticsInstance = null;
const analyticsReady = isSupported().then((yes) => {
  if (yes) {
    analyticsInstance = getAnalytics(app);
  }
  return yes;
});

function track(eventName, params) {
  if (analyticsInstance) {
    logEvent(analyticsInstance, eventName, params);
  } else {
    analyticsReady.then((ok) => {
      if (ok && analyticsInstance) logEvent(analyticsInstance, eventName, params);
    });
  }
}

import { track as mpTrack } from "@/lib/mixpanel";

// ── Reusable tracking functions (Firebase + Mixpanel mirror) ──

export const trackAppLoaded = () => { track("app_loaded"); mpTrack("app_loaded"); };

export const trackDealViewed = (businessId, businessName) => {
  track("deal_viewed", { business_id: businessId, business_name: businessName });
  mpTrack("deal_viewed", { business_id: businessId, business_name: businessName });
};

export const trackOfferSaved = (businessId, businessName) => {
  track("offer_saved", { business_id: businessId, business_name: businessName });
  mpTrack("offer_saved", { business_id: businessId, business_name: businessName });
};

export const trackSearchPerformed = (query) => {
  track("search_performed", { search_term: query });
  mpTrack("search_performed", { search_term: query });
};

export { app as firebaseApp, analyticsReady };
